import type { BioContext } from '@ps/functions/bio/bioContext';
import { bioUrl } from '@ps/functions/bio/bioUrls';
import { PopStoreExtendedSubscriptionLevel } from '@ps/models/lib/creator-subscription';

/**
 * The subscribe-picker URL for the DM gate — mirrors PopshopRN's
 * `navigation.push('subscribe', { defaultLevel, minLevel })`: the required tier is
 * both **preselected** (`defaultLevel`) and **floored** (`minLevel`, so lower tiers
 * render disabled). When the creator set no `dmMinimumSubscriptionLevel` (the
 * "any subscriber" default) we preselect SUBSCRIBER without a floor, matching
 * upstream's `?? SUBSCRIBER` fallback.
 *
 * Soft-navigating to this URL hits the bio's `@modal/(.)subscribe` intercept, so
 * the picker overlays the live bio.
 */
export function dmSubscribeHref(
  bioContext: BioContext,
  dmMinimumSubscriptionLevel?: PopStoreExtendedSubscriptionLevel,
): string {
  return bioUrl(bioContext).subscribe({
    defaultLevel:
      dmMinimumSubscriptionLevel ??
      PopStoreExtendedSubscriptionLevel.SUBSCRIBER,
    minLevel: dmMinimumSubscriptionLevel,
  });
}
